import "./CTProductCostSetup.scss";
import TextArea from "../../components/Form/TextArea/TextArea";
import InputBox from "../../components/Form/InputBox/InputBox";
import { useEffect, useMemo, useState } from "react";
import {
  MotifButton,
  MotifErrorMessage,
  MotifTooltip,
  MotifIcon,
  MotifIconButton,
} from "@ey-xd/motif-react";
import {
  isStringHavingSpecialChars,
  isValidUrl,
  isValidUrlWithWWW,
  ltrimString,
} from "../../utils/Validator";
import {
  MORE_INFORMATION,
  COMMERCIAL_DESCRIPTION,
  COMMERCIAL_OWNER_NAME,
  COMMERCIAL_OWNER_PROXY_NAME,
  CREATE_NEW_SKUS,
  CT_PORTFOLIO,
  CT_PRODUCT_MANAGER,
  DEMAND_MANAGEMENT_TEAM_ID,
  DEMAND_MANAGEMENT_TEAM_ID_LABEL,
  DEMAND_MANAGEMENT_TEAM_ID_URL,
  DESCRIPTION,
  EMAIL_ID_PLACEHOLDER,
  EMPIRE_CODE,
  EMPIRE_CODE_PLACEHOLDER,
  GLOBAL_SERVICE_CODE,
  GLOBAL_SERVICE_CODE_PRIMARY_LIST,
  GLOBAL_SERVICE_CODE_SECONDARY_LIST,
  PRIMARY_LIST_PLACEHOLDER,
  PRODUCT_CONTACTS,
  PRODUCT_COST_SETUP,
  PRODUCT_DESCRIPTION,
  PRODUCT_DETAILS_LABEL,
  PRODUCT_NAME,
  PRODUCT_SUPPORT_LINK,
  SAVE_DRAFT,
  SECONDARY_LIST_PLACEHOLDER,
  SKUS,
  SUPPORT,
  SUPPORT_LINK,
  SUPPORT_LINK_NAME,
  TEAM_EMAIL_ID,
  DOWNLOAD_API_KEYS,
  PRODUCT_RESOURCES,
  PRODUCT_RESOURCES_LIMIT,
} from "./Constants";
import {
  IconoirPlus,
  IconoirFloppyDisk,
  IconoirArrowLeft,
  IconoirNotes,
  IconoirLink,
  IconoirCloudUpload,
  IconoirDownload,
  IconoirEditPencil,
  IconoirTrash,
  IconoirOpenNewWindow,
} from "@ey-xd/motif-icon";
import NotificationGrid from "../../components/Notification/NotificationGrid";
import {
  PAGE_NO_ACCESS,
  FORM_LABEL_DESCRIPTION,
  GLOBAL_NOTIFICATION,
} from "../../Constant";
import Loader from "../../components/Loader";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router";
import Breadcrumb from "../../components/Breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../store";
import { mapProductAPIDataWithFormFields, validateFormFields } from "./Helper";
import {
  fetchProductDetailsData,
  resetProductDetailState,
} from "../../store/slices/CTDBProductDetailsSlice";
import {
  fetchSKUApiKeyStatus,
  resetSKUApiKeyStatusState,
  fetchSKUKeysExportData,
} from "../../store/slices/CTSKUApiKeyStatusSlice";
import SkuList from "./SkuList";
import { useParams } from "react-router";
import CreateSkuModal from "../CreateSku/CreateSkuModal";
import MultiSelectUserSearch from "../../components/Form/MultiSelectUserSearch/MultiSelectUserSearch";
import { ApiStatus } from "../../utils/apiStatus.enum";
import {
  resetUpdateProductState,
  updateProduct,
} from "../../store/slices/CTDBUpdateProductSlice";
import {
  assignProxy,
  resetAssignProxyState,
} from "../../store/slices/CTDBAssignProxySlice";
import { RichTextEditor } from "../../components/Form/RichTextEditor/RichTextEditor";
import InfoTooltip from "../../components/InfoTooltip";
import ArtifactsModal from "../../components/ArtifactsModal/ArtifactsModal";
import {
  deleteArtifactFileData,
  fetchArtifactDetailsData,
  fetchArtifactFileData,
  resetArtifactDetailState,
} from "../../store/slices/CTArtifactDetailsSlice";
import { downloadBase64File, urlify } from "../../utils/common";
import { fetchSkuConfigData } from "../../store/slices/CTDBSkuConfigSlice";
import ArtifactDeleteModal from "../../components/ArtifactDeleteModal/ArtifactDeleteModal";
import { SKUToast } from "../../components/SKUToast/SKUToast";
import NoAccess from "../../components/NoAccess";
import UserSearchSelect from "../../components/UserSearchSelect";

interface ProxyOwner {
  Name: string;
  Email: string;
}

export interface ArtifactType {
  ProductArtifactId: string;
  ProductId: string;
  Title: string;
  Description: string;
  URL: string;
  ArtifactTypeCd: string;
  ArtifactCategoryCd: string;
  IsActive: boolean;
  CreatedUser: string;
  UpdatedUser: string;
  FileSize: number | null;
}

const CTProductCostSetup = () => {
  const initialValues = {
    empireCode: "",
    productName: "",
    productDescription: "",
    commercialDescription: "",
    assetAdvice: "",
    ctPrortfolio: "",
    primaryList: "",
    secondryList: "",
    commercialOwnerName: "",
    commercialOwnerProxyName: "",
    ctTechnicalProductManager: "",
    managementTeamID: "",
    teamEmailID: "",
    productContact: "",
    productSupport: "",
    productSupportText: "",
  };
  const [showCreateNewSkus, setShowCreateNewSkus] = useState(false);
  const [reloadOnNewCreation, setReloadOnNewCreation] = useState(false);

  const [proxyOwners, setProxyOwners] = useState<ProxyOwner[]>([]);
  const [productContacts, setProductContacts] = useState<ProxyOwner[] | null>(
    [],
  );
  const [resetSearch, setResetSearch] = useState(false);
  const [isApiKeysAvailable, setIsApiKeysAvailable] = useState(false);
  const [isExportApiLoading, setIsExportApiLoading] = useState(false);
  const [exportErrorMessage, setExportErrorMessage] = useState("");
  const [isAnySKUretired, setIsAnySKUretired] = useState(false);
  const [showArtifactsModal, setShowArtifactsModal] = useState(false);
  const [showEditArtifactsModal, setShowEditArtifactsModal] = useState(false);
  const [artifactToEdit, setArtifactToEdit] = useState<
    ArtifactType | undefined
  >(undefined);
  const [artifactSuccessMessage, setArtifactSuccessMessage] = useState("");
  const [showArtifactDeleteModal, setShowArtifactDeleteModal] = useState(false);
  const [artifactDeleteModalItem, setArtifactDeleteModalItem] =
    useState<ArtifactType | null>(null);
  const [isArtifactsDeleteLoading, setIsArtifactsDeleteLoading] =
    useState(false);
  const [isArtifactsDeleteError, setIsArtifactsDeleteError] = useState(false);

  const dispatch = useDispatch<AppDispatch>();

  const param = useParams();
  const [searchParams] = useSearchParams();

  const skuId = searchParams.get("sku-id") || "";

  const navigate = useNavigate();

  const isLoadingAPi = useSelector(
    (state: RootState) => state.CTDBProductDetailsSlice.isLoading,
  );
  const data = useSelector(
    (state: RootState) => state.CTDBProductDetailsSlice.data,
  );
  const errorAPi = useSelector(
    (state: RootState) => state.CTDBProductDetailsSlice.error,
  );

  const userPermissionsStatus: ApiStatus = useSelector(
    (state: RootState) => state.UserProfileSlice.userPermissionsStatus,
  );

  const userPermissionsData: string[] = useSelector(
    (state: RootState) => state.UserProfileSlice.userPermissions,
  );

  const userEntityData = useSelector(
    (state: RootState) => state.UserProfileSlice.userEntityData,
  );

  const userEmailInStore: string = useSelector(
    (state: RootState) => state.UserProfileSlice.emailId,
  );

  const updateProductIsLoadingAPi = useSelector(
    (state: RootState) => state.CTDBUpdateProductSlice.isLoading,
  );
  const updateProductData = useSelector(
    (state: RootState) => state.CTDBUpdateProductSlice.data,
  );
  const updateProductErrorAPi = useSelector(
    (state: RootState) => state.CTDBUpdateProductSlice.error,
  );

  const skuApiKeyStatusLoading = useSelector(
    (state: RootState) => state.CTSKUApiKeyStatusSlice.isLoading,
  );
  const skuApiKeyStatusData = useSelector(
    (state: RootState) => state.CTSKUApiKeyStatusSlice.data,
  );

  // const isArtifactDataLoading = useSelector(
  //   (state: RootState) => state.CTArtifactDetailsSlice.isLoading,
  // );

  const artifactData = useSelector(
    (state: RootState) => state.CTArtifactDetailsSlice.data,
  );

  // const errorArtifactData = useSelector(
  //   (state: RootState) => state.CTArtifactDetailsSlice.error,
  // );

  const configData = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.data,
  );

  const isCommericalOwner = () => {
    if (userPermissionsStatus === ApiStatus.SUCCESS && data !== null) {
      const productOwnerList = data?.Data?.ProductOwner;
      if (!productOwnerList) {
        return false;
      }
      if (productOwnerList.length > 0) {
        const skuDatabasePermission = productOwnerList.filter(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (productOwner: any) =>
            productOwner.Email.toLowerCase() === userEmailInStore.toLowerCase(),
        ).length;
        return skuDatabasePermission > 0 ? true : false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const isCommercialProxyOwner = () => {
    if (userPermissionsStatus === ApiStatus.SUCCESS && data !== null) {
      const proxyOwnerList = data?.Data?.ProxyOwner;
      if (!proxyOwnerList) {
        return false;
      }
      if (proxyOwnerList.length > 0) {
        const skuDatabasePermission = proxyOwnerList.filter(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (proxyOwner: any) =>
            proxyOwner.Email.toLowerCase() === userEmailInStore.toLowerCase(),
        ).length;
        return skuDatabasePermission > 0 ? true : false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  window.addEventListener("popstate", function () {
    dispatch(resetProductDetailState());
  });

  const isConsumptionManager = useMemo(() => {
    if (
      data === null ||
      param.id === null ||
      param.id !== data?.Data?.ProductId
    ) {
      return false;
    }
    if (
      userPermissionsData.length === 0 ||
      !userPermissionsData?.includes("sku_consumptionmgr") ||
      isCommercialProxyOwner() ||
      isCommericalOwner()
    ) {
      return false;
    } else {
      const isProductsReadonly = userEntityData.find((userEntity) => {
        return (
          userEntity.RoleCd === "sku_consumptionmgr" &&
          userEntity.EntityId.includes(param.id || "")
        );
      });
      return isProductsReadonly !== undefined;
    }
  }, [userPermissionsData, userEntityData, param.id, data]);

  const [formFields, setFormFields] = useState<{ [key: string]: string }>(
    initialValues,
  );
  const isHavingSkus = true;

  const [isHavingSkusError, setIsHavingSkusError] = useState(false);
  const [notificationVisible, setNotificationVisible] = useState({
    notificationVisible: false,
    message: "",
    type: "",
  });

  const resetErrors = () => {
    setError(errorInitial);
    setIsHavingSkusError(false);
    setNotificationVisible({
      ...notificationVisible,
      notificationVisible: false,
      message: "",
      type: "",
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
    setResetSearch(true);
  }, []);

  useEffect(() => {
    if (data && data !== null && param.id !== data?.Data?.ProductId) {
      dispatch(resetProductDetailState());
    }
    if (param.id !== undefined) {
      dispatch(
        fetchProductDetailsData({
          productId: param.id,
        }),
      );
      dispatch(resetSKUApiKeyStatusState());
      dispatch(
        fetchSKUApiKeyStatus({
          Action: "exportSkuKeysStatus",
          ProductId: param.id,
        }),
      );
      dispatch(fetchSkuConfigData());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, param.id]);

  useEffect(() => {
    if (
      artifactData &&
      artifactData !== null &&
      param.id !== data?.Data?.ProductId
    ) {
      dispatch(resetArtifactDetailState());
    }
    if (param.id !== undefined) {
      dispatch(
        fetchArtifactDetailsData({
          productId: param.id || "",
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, param.id]);

  useEffect(() => {
    if (isAnySKUretired) {
      dispatch(resetSKUApiKeyStatusState());
      dispatch(
        fetchSKUApiKeyStatus({
          Action: "exportSkuKeysStatus",
          ProductId: param.id,
        }),
      );
      setIsAnySKUretired(false);
    }
  }, [isAnySKUretired]);

  useEffect(() => {
    if (skuApiKeyStatusData && skuApiKeyStatusData.Data) {
      setIsApiKeysAvailable(skuApiKeyStatusData.Data.skuKeyeExportEnable);
    } else {
      setIsApiKeysAvailable(false);
    }
  }, [skuApiKeyStatusData]);

  useEffect(() => {
    if (data !== null && data !== undefined) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const productFormData = mapProductAPIDataWithFormFields(data?.Data);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setFormFields(productFormData);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setProxyOwners(data?.Data?.ProxyOwner);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setProductContacts(data?.Data?.ProductContact);
    }
  }, [data]);

  useEffect(() => {
    if (data !== null) {
      for (const [key, value] of Object.entries(formFields)) {
        validateFormFields(key, value, error, setError);
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    () => {
      resetErrors();
      dispatch(resetProductDetailState());
      dispatch(resetUpdateProductState());
    };
  }, [formFields]);

  const location = useLocation();

  useEffect(() => {
    resetErrors();
    dispatch(resetProductDetailState());
    dispatch(resetUpdateProductState());
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    () => {
      resetErrors();
      dispatch(resetProductDetailState());
      dispatch(resetUpdateProductState());
    };
  }, [location]);

  useEffect(() => {
    if (artifactSuccessMessage !== "") {
      setTimeout(function () {
        setArtifactSuccessMessage("");
      }, 5000);
    }
  }, [artifactSuccessMessage]);

  const errorInitial = {
    empireCode: {
      isError: false,
      message: "",
      isDirty: false,
      label: EMPIRE_CODE,
      validation: ["required"],
      maxLengthLimit: 0,
    },
    productName: {
      isError: false,
      message: "",
      isDirty: false,
      label: PRODUCT_NAME,
      validation: ["required"],
      maxLengthLimit: 0,
    },
    commercialDescription: {
      isError: false,
      message: "",
      isDirty: false,
      label: COMMERCIAL_DESCRIPTION,
      validation: ["required", "maxLength", "richTextEmptyCheck"],
      maxLengthLimit: 0,
    },
    assetAdvice: {
      isError: false,
      message: "",
      isDirty: false,
      label: MORE_INFORMATION,
      validation: ["required", "maxLength", "richTextEmptyCheck"],
      maxLengthLimit: 0,
    },
    primaryList: {
      isError: false,
      message: "",
      isDirty: false,
      label: GLOBAL_SERVICE_CODE_PRIMARY_LIST,
      validation: ["isNumber"],
      maxLengthLimit: 0,
    },
    secondryList: {
      isError: false,
      message: "",
      isDirty: false,
      label: GLOBAL_SERVICE_CODE_SECONDARY_LIST,
      validation: ["isNumber"],
      maxLengthLimit: 0,
    },
    productSupport: {
      isError: false,
      message: "",
      isDirty: false,
      label: SUPPORT_LINK,
      validation: ["isUrl"],
      maxLengthLimit: 0,
    },
    productSupportText: {
      isError: false,
      message: "",
      isDirty: false,
      label: SUPPORT_LINK_NAME,
      validation: ["maxLength"],
      maxLengthLimit: 80,
    },
  };

  const [error, setError] = useState(errorInitial);
  const {
    empireCode: empireCodeError,
    productName: productNameError,
    assetAdvice: assetAdviceError,
    primaryList: primaryListError,
    secondryList: secondryListError,
    productSupport: productSupportError,
    productSupportText: productSupportTextError,
  } = error;

  const isValidForm = async () => {
    let isValid = true;
    for (const [key, value] of Object.entries(formFields)) {
      const isNotValidField = validateFormFields(key, value, error, setError);
      if (isNotValidField) {
        isValid = false;
      }
    }
    return isValid;
  };

  const isDisplayNameValid = (value: string) => {
    // Allows letters, numbers, spaces, hyphens, underscores, periods, commas, apostrophes, parentheses
    return /^[\w\s\-.,'()]+$/.test(value);
  };

  const handleChange = (event: { target: { name: string; value: string } }) => {
    const { name, value } = event.target;
    let val = ltrimString(value);

    if (name === "productSupportText") {
      let errorMsg = "";
      if (val.length > 80) {
        errorMsg = "The Name must be 80 characters or fewer.";
      } else if (val && !isDisplayNameValid(val)) {
        errorMsg =
          "The Name can only contain letters, numbers, spaces, hyphens, underscores, periods, commas, apostrophes, and parentheses.";
      }
      setError((prev) => ({
        ...prev,
        productSupportText: {
          ...prev.productSupportText,
          isError: !!errorMsg,
          message: errorMsg,
        },
      }));
    }
    if (
      isStringHavingSpecialChars(val) &&
      name !== "productSupport" &&
      name !== "commercialDescription" &&
      name !== "assetAdvice" &&
      name !== "productSupportText"
    ) {
      return;
    }

    if (name == "productSupport") {
      val = normalizeUrl(value);
    }

    setFormFields(() => {
      return {
        ...formFields,
        [name]: val,
      };
    });
    validateFormFields(name, val, error, setError);
  };

  const normalizeUrl = (url: string) => {
    // Check if protocol exists
    const hasProtocol = /^https?:\/\//i.test(url);

    if (hasProtocol) {
      // Lowercase protocol + domain only
      // eslint-disable-next-line no-useless-escape
      return url.replace(/^([a-z]+):\/\/([^\/]+)/i, (_, protocol, domain) => {
        return protocol.toLowerCase() + "://" + domain.toLowerCase();
      });
    } else {
      // No protocol → lowercase domain only (before first slash)
      // eslint-disable-next-line no-useless-escape
      return url.replace(/^([^\/]+)/, (domain) => domain.toLowerCase());
    }
  };

  const handleBlur = (event: { target: { name: string; value: string } }) => {
    const { name, value } = event.target;
    let val = normalizeUrl(ltrimString(value));
    const urlRegex = /^https?:\/\//i;
    if (val && isValidUrlWithWWW(value) && !urlRegex.test(val)) {
      val = "https://" + val;
      setFormFields(() => {
        return {
          ...formFields,
          [name]: val,
        };
      });
      validateFormFields(name, val, error, setError);
    }
  };

  const handleSaveDraft = async () => {
    setResetSearch(false);
    resetErrors();
    const validFormStatus = await isValidForm();
    let isErrorExist = false;

    for (const errorField in error) {
      if (error[errorField as keyof typeof error]["isError"])
        isErrorExist = true;
    }

    if (!validFormStatus || isErrorExist) {
      let errorMessage = GLOBAL_NOTIFICATION.INVALID_FORM;
      for (const errorField in error) {
        const fieldError = error[errorField as keyof typeof error];
        if (fieldError["isError"] && fieldError["message"]) {
          errorMessage = fieldError["message"];
          break;
        }
      }
      setNotificationVisible({
        ...notificationVisible,
        notificationVisible: true,
        message: errorMessage,
        type: "error",
      });
      return false;
    }
    if (!isHavingSkus) {
      setIsHavingSkusError(true);
      return false;
    }
    setResetSearch(true);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const removeObjectKeys = (obj: any) => {
      if (obj === null || obj === undefined) {
        return obj;
      }
      if ("EntityId" in obj && "RoleCd" in obj) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { EntityId, RoleCd, ...filterObj } = obj;
        return filterObj;
      }
      return obj;
    };
    const productContact = productContacts?.map(removeObjectKeys);
    const commercialOwnerProxyName = proxyOwners ? proxyOwners : null;

    const {
      empireCode,
      commercialDescription,
      assetAdvice,
      primaryList,
      secondryList,
      productSupport,
      productSupportText,
    } = formFields;
    const formData = {
      ProductId: empireCode,
      CommercialDescription: commercialDescription,
      AssetAdvice: assetAdvice,
      GlobalServiceCodesPrimary: primaryList,
      GlobalServiceCodesSecondary: secondryList,
      ProductContact: productContact || [],
      ProductSupport: productSupport || "",
      ProductSupportText: productSupportText || "",
    };

    try {
      const response = await dispatch(updateProduct(formData));
      if (response.payload.Status === "success") {
        const isCommercialOwner = isCommericalOwner();
        if (!isCommercialOwner) {
          dispatch(resetAssignProxyState());
          setNotificationVisible({
            ...notificationVisible,
            notificationVisible: true,
            message: GLOBAL_NOTIFICATION.UPDATED_SUCCESSFULLY,
            type: "success",
          });
          dispatch(
            fetchProductDetailsData({
              productId: param.id || "",
            }),
          );
        } else {
          try {
            const response = await dispatch(
              assignProxy({
                productId: empireCode,
                proxyOwners: commercialOwnerProxyName
                  ? commercialOwnerProxyName
                  : [],
              }),
            );
            if (response.payload.Status === "success") {
              dispatch(resetAssignProxyState());
              setNotificationVisible({
                ...notificationVisible,
                notificationVisible: true,
                message: GLOBAL_NOTIFICATION.UPDATED_SUCCESSFULLY,
                type: "success",
              });
              dispatch(
                fetchProductDetailsData({
                  productId: param.id || "",
                }),
              );
            }
            // Add any additional logic here if needed
          } catch (error) {
            console.log("Error in update proxy owners", error);
            setNotificationVisible({
              ...notificationVisible,
              notificationVisible: true,
              message: GLOBAL_NOTIFICATION.UNEXPECTED_ERROR,
              type: "error",
            });
          }
        }
      }
      // Add any additional logic here if needed
    } catch (error) {
      console.log("Error in update Product", error);
      console.log("updateProductData", updateProductData);
      setNotificationVisible({
        ...notificationVisible,
        notificationVisible: true,
        message: GLOBAL_NOTIFICATION.UNEXPECTED_ERROR,
        type: "error",
      });
    }
  };

  const refetchArtifacts = (message: string) => {
    dispatch(fetchArtifactDetailsData({ productId: param.id || "" }));
    setArtifactSuccessMessage(message);
  };

  const downloadSKUKeysFile = async () => {
    setExportErrorMessage("");
    setIsExportApiLoading(true);
    try {
      const payload = { Action: "exportSkuKeys", ProductId: param.id };
      const response = await dispatch(fetchSKUKeysExportData(payload));
      if (response.payload?.message) {
        setIsExportApiLoading(false);
        setExportErrorMessage("Something went wrong. Please try again.");
      } else {
        setExportErrorMessage("");
        const blob = new Blob([response.payload], {
          type: "text/plain;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ch-sku-keys.env");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        setIsExportApiLoading(false);
      }
    } catch (error) {
      setIsExportApiLoading(false);
      console.error("Failed to place order:", error);
      setExportErrorMessage("Something went wrong. Please try again.");
    }
  };

  const {
    empireCode,
    productDescription,
    assetAdvice,
    commercialDescription,
    ctPrortfolio,
    primaryList,
    secondryList,
    commercialOwnerName,
    ctTechnicalProductManager,
    productSupport,
    teamEmailID,
    productName,
    productSupportText,
  } = formFields;
  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "product name",
      elementKey: "submission",
      text: productName,
      url: `/ct/product/${empireCode}/preview`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "product cost setup",
      elementKey: "submission",
      text: "Product Cost Setup",
      url: `/ct/product/${empireCode}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled: true,
    },
  ];

  const handleDownloadClick = async (item: ArtifactType) => {
    if (item.ArtifactTypeCd === "prodarttype_doc") {
      const fileData = await dispatch(
        fetchArtifactFileData({
          productId: item.ProductId,
          productArtifactId: item.ProductArtifactId,
        }),
      );
      if (fileData && fileData.payload.Status === "success") {
        downloadBase64File(
          fileData.payload.Data.fileContent,
          fileData.payload.Data.fileName,
          fileData.payload.Data.contentType,
        );
      } else {
        console.log("Something went wrong. Please try again.");
      }
    } else if (item.ArtifactTypeCd === "prodarttype_link") {
      if (isValidUrl(item.URL)) {
        window.open(urlify(item.URL), "_blank", "noopener,noreferrer");
      }
    } else {
      console.log("Something went wrong. Please try again.");
    }
  };

  const hasAnyProductError = Object.values(error || {}).some(
    (field) => field.isError === true,
  );

  const handleDeleteArtifactClick = (item: ArtifactType | null) => {
    setShowArtifactDeleteModal(true);
    setArtifactDeleteModalItem(item);
  };

  const handleDeleteArtifactConfirm = async (item: ArtifactType | null) => {
    setIsArtifactsDeleteLoading(true);
    setIsArtifactsDeleteError(false);
    const fileData = await dispatch(
      deleteArtifactFileData({
        productId: item?.ProductId,
        productArtifactId: item?.ProductArtifactId,
        ResourceType: item?.ArtifactTypeCd,
      }),
    );
    if (fileData && fileData.payload.Status === "success") {
      setIsArtifactsDeleteLoading(false);
      setShowArtifactDeleteModal(false);
      setArtifactDeleteModalItem(null);
      refetchArtifacts("Artifact has been deleted successfully.");
    } else {
      setIsArtifactsDeleteLoading(false);
      setIsArtifactsDeleteError(true);
    }
  };
  if (
    userPermissionsData.length === 0 ||
    isLoadingAPi ||
    userPermissionsStatus === ApiStatus.LOADING
  ) {
    return <Loader />;
  }
  if (
    !isConsumptionManager &&
    !isCommericalOwner() &&
    !isCommercialProxyOwner() &&
    data?.Status === "success"
  ) {
    return (
      <NoAccess
        headerText={PAGE_NO_ACCESS.HEADER}
        descriptionText={PAGE_NO_ACCESS.DESCRIPTION}
        descriptionText2={PAGE_NO_ACCESS.SUGGESTION}
        buttonLabel={PAGE_NO_ACCESS.BUTTON_LABEL}
        onClickHandler={() => navigate("/")}
        className={"page-no-access"}
      />
    );
  }
  return (
    <div className="CTProductCostSetup">
      <div className="motif-row no-gutter">
        <div className="motif-col-lg-12 main-content-header">
          <div className="motif-container product-cost-setup-header">
            <div className="motif-row">
              <div className="motif-col-lg-12">
                <div className="product-cost-setup-bredcrumb">
                  <Breadcrumb
                    items={breadcrumbItems}
                    ariaLabel="Breadcrumb navigation"
                  />
                </div>
              </div>
            </div>
            <div className="motif-row">
              <div className="motif-col-lg-12">
                <h1 className="header-tile">{PRODUCT_COST_SETUP}</h1>
              </div>
            </div>
            <div className="motif-row">
              <div className="motif-col-lg-12">
                <div className="product-cost-setup-header-content">
                  {productDescription}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="main-content">
        {(isLoadingAPi || skuApiKeyStatusLoading) && (
          <div className="motif-row mar-b-20">
            <div className="motif-col-lg-12">
              <Loader />
            </div>
          </div>
        )}

        {notificationVisible?.notificationVisible &&
          notificationVisible?.type === "success" && (
            <div className="motif-row mar-b-20">
              <div className="motif-col-lg-12">
                <NotificationGrid
                  show={notificationVisible?.notificationVisible}
                  message={GLOBAL_NOTIFICATION.UPDATED_SUCCESSFULLY}
                  type="success"
                />
              </div>
            </div>
          )}
        {/* error for APi failure*/}
        {errorAPi && (
          <div className="motif-row mar-b-20">
            <div className="motif-col-lg-12">
              <NotificationGrid
                show={errorAPi !== undefined}
                message={GLOBAL_NOTIFICATION.UNEXPECTED_ERROR}
                type="error"
              />
            </div>
          </div>
        )}
        {updateProductErrorAPi && (
          <div className="motif-row mar-b-20">
            <div className="motif-col-lg-12">
              <NotificationGrid
                show={true}
                message={updateProductErrorAPi}
                type="error"
              />
            </div>
          </div>
        )}
        {exportErrorMessage && (
          <div className="motif-row mar-b-20">
            <div className="motif-col-lg-12">
              <NotificationGrid
                show={true}
                message={exportErrorMessage}
                type="error"
              />
            </div>
          </div>
        )}

        {notificationVisible?.notificationVisible &&
          notificationVisible?.type === "error" &&
          (!errorAPi || !updateProductErrorAPi) && (
            <div className="motif-row mar-b-20">
              <div className="motif-col-lg-12">
                <NotificationGrid
                  show={notificationVisible?.notificationVisible}
                  message={notificationVisible?.message}
                  type="error"
                />
              </div>
            </div>
          )}
        <div className="motif-row heading">
          <div className="motif-col-lg-12">
            <div className="title">{PRODUCT_DETAILS_LABEL}</div>
          </div>
        </div>

        <div className="motif-row form-item-row double-row">
          <div className="motif-col-lg">
            <div className="motif-row">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">{EMPIRE_CODE}</div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <InputBox
                      ariaLabel=""
                      label=""
                      onChange={handleChange}
                      name={"empireCode"}
                      value={empireCode}
                      placeholder={EMPIRE_CODE_PLACEHOLDER}
                      error={empireCodeError}
                      readonly={true}
                      hideClearButton={true}
                    />
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-example"
                    >
                      {empireCodeError ? empireCodeError.message : ""}
                    </MotifErrorMessage>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-col-lg">
            <div className="motif-row right-content">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">{PRODUCT_NAME}</div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <InputBox
                      ariaLabel=""
                      label=""
                      onChange={handleChange}
                      name={"productName"}
                      value={productName}
                      placeholder={PRODUCT_NAME}
                      readonly={true}
                      hideClearButton={true}
                    />
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-example"
                    >
                      {productNameError ? productNameError.message : ""}
                    </MotifErrorMessage>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-row form-item-row single-row">
          <div className="motif-col-lg-2  form-item label-item">
            <div className="label">{PRODUCT_DESCRIPTION}</div>
            <InfoTooltip
              description={FORM_LABEL_DESCRIPTION.PRODUCT_DESCRIPTION}
              id={PRODUCT_DESCRIPTION}
            />
          </div>
          <div className="motif-col-lg-10  form-item">
            <div className="value">
              <div className="inputField">
                <TextArea
                  ariaLabel=""
                  label=""
                  name={"productDescription"}
                  readonly={true}
                  hideClearButton={true}
                  value={productDescription}
                  placeholder={DESCRIPTION}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="motif-row form-item-row single-row">
          <div className="motif-col-lg-2 form-item label-item">
            <div className="label">
              {COMMERCIAL_DESCRIPTION}
              <span className="required">*</span>
              :
              <InfoTooltip
                description={FORM_LABEL_DESCRIPTION.COMMERCIAL_DESCRIPTION}
                id={COMMERCIAL_DESCRIPTION}
              />
            </div>
          </div>
          <div className="motif-col-lg-10 form-item">
            <RichTextEditor
              name={"commercialDescription"}
              placeholder={"Description"}
              value={commercialDescription}
              handleChange={handleChange}
              readOnly={isConsumptionManager}
              className={isConsumptionManager ? "disabled" : ""}
            />
            <MotifErrorMessage
              aria-live="assertive"
              role="alert"
              id="aria-error-example"
            >
              {error?.commercialDescription?.isError
                ? error?.commercialDescription?.message
                : ""}
            </MotifErrorMessage>
          </div>
        </div>
        <div className="motif-row form-item-row single-row">
          <div className="motif-col-lg-2 form-item label-item">
            <div className="label">
              {MORE_INFORMATION}
              <span className="required">*</span>:
              <InfoTooltip
                description={FORM_LABEL_DESCRIPTION.MORE_INFORMATION}
                id={MORE_INFORMATION}
              />
            </div>
          </div>
          <div className="motif-col-lg-10 form-item">
            <RichTextEditor
              name={"assetAdvice"}
              placeholder={"Description"}
              value={assetAdvice}
              handleChange={handleChange}
              readOnly={isConsumptionManager}
              className={isConsumptionManager ? "disabled" : ""}
            />
            <MotifErrorMessage
              aria-live="assertive"
              role="alert"
              id="aria-error-example"
            >
              {assetAdviceError ? assetAdviceError.message : ""}
            </MotifErrorMessage>
          </div>
        </div>
        <div className="motif-row form-item-row single-row">
          <div className="motif-col-lg-2 form-item label-item">
            <div className="label">
              {CT_PORTFOLIO}
              <InfoTooltip
                description={FORM_LABEL_DESCRIPTION.CT_PORTFOLIO}
                id={CT_PORTFOLIO}
              />
            </div>
          </div>
          <div className="motif-col-lg-10 form-item">
            <div className="value">
              <InputBox
                name={"ctPrortfolio"}
                ariaLabel=""
                label=""
                onChange={handleChange}
                placeholder={DESCRIPTION}
                value={ctPrortfolio}
                readonly={true}
                hideClearButton={true}
              />
            </div>
          </div>
        </div>
        <div className="motif-row heading">
          <div className="motif-col-lg-12">
            <div className="title">{PRODUCT_RESOURCES}</div>
          </div>
        </div>
        <div className="motif-row product-resources-list">
          {(isCommericalOwner() ||
            isCommercialProxyOwner() ||
            isConsumptionManager) && (
            <div
              className={`product-resource-card-upload ${
                isConsumptionManager ||
                (artifactData &&
                  artifactData.Data &&
                  artifactData.Data.length >= PRODUCT_RESOURCES_LIMIT)
                  ? "disabled"
                  : ""
              }`}
              onClick={() => {
                if (!isConsumptionManager) {
                  if (
                    artifactData &&
                    artifactData.Data &&
                    artifactData.Data.length < PRODUCT_RESOURCES_LIMIT
                  )
                    setShowArtifactsModal(true);
                }
              }}
            >
              {artifactData &&
              artifactData.Data &&
              artifactData.Data.length < PRODUCT_RESOURCES_LIMIT ? (
                <>
                  <MotifIcon src={IconoirCloudUpload} />
                  <span className="upload-text">Upload Resource</span>
                </>
              ) : (
                <>
                  <MotifIcon src={IconoirCloudUpload} />
                  <span className="upload-text">Resource limit reached</span>
                  <span className="upload-subtext">
                    You've reached the limit of {PRODUCT_RESOURCES_LIMIT}{" "}
                    resources.
                  </span>
                  <span className="upload-subtext">
                    Delete a resource to upload a new one.
                  </span>
                </>
              )}
            </div>
          )}

          {artifactData &&
            artifactData !== null &&
            artifactData.Data?.map((item: any) => (
              <div
                className="product-resource-card"
                key={item.ProductArtifactId}
              >
                <div className="left">
                  <div className="icon-wrapper">
                    <MotifIcon
                      size="20"
                      iconFunction={
                        item.ArtifactTypeCd === "prodarttype_doc"
                          ? IconoirNotes
                          : IconoirLink
                      }
                    />
                  </div>
                </div>
                <div className="right">
                  <div className="resource-content">
                    <div className="resource-title">{item.Title}</div>
                    <div className="resource-category">
                      {configData?.CommercialStatus.filter(
                        (category) =>
                          category.StatusType === "prodartcatg" &&
                          category.StatusCd === item.ArtifactCategoryCd,
                      ).map((category) => category.Name)}
                    </div>
                    <div className="resource-description">
                      {item.Description}
                    </div>
                  </div>

                  {!isConsumptionManager && (
                    <div className="resource-actions">
                      {item.ArtifactTypeCd === "prodarttype_doc" ? (
                        <MotifIconButton
                          onClick={() => handleDownloadClick(item)}
                          aria-label="Download Resource"
                        >
                          <MotifIcon
                            size="20"
                            iconFunction={IconoirDownload}
                            className="resource-action-icon"
                          />
                        </MotifIconButton>
                      ) : (
                        <MotifIconButton
                          onClick={() => handleDownloadClick(item)}
                          aria-label="Open Link"
                        >
                          <MotifIcon
                            size="20"
                            iconFunction={IconoirOpenNewWindow}
                            className="resource-action-icon"
                          />
                        </MotifIconButton>
                      )}
                      {(isCommericalOwner() || isCommercialProxyOwner()) && (
                        <MotifIconButton
                          onClick={() => {
                            setShowEditArtifactsModal(true);
                            setArtifactToEdit(item);
                          }}
                          aria-label="Edit Resource"
                        >
                          <MotifIcon
                            size="20"
                            iconFunction={IconoirEditPencil}
                            className="resource-action-icon"
                          />
                        </MotifIconButton>
                      )}

                      {(isCommericalOwner() || isCommercialProxyOwner()) && (
                        <MotifIconButton
                          onClick={() => handleDeleteArtifactClick(item)}
                          aria-label="Delete Resource"
                        >
                          <MotifIcon
                            size="20"
                            iconFunction={IconoirTrash}
                            className="resource-action-icon"
                          />
                        </MotifIconButton>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
        <div className="motif-row heading">
          <div className="motif-col-lg-12">
            <div className="title">{GLOBAL_SERVICE_CODE}</div>
          </div>
        </div>
        <div className="motif-row form-item-row double-row">
          <div className="motif-col-lg">
            <div className="motif-row">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">{GLOBAL_SERVICE_CODE_PRIMARY_LIST}</div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <InputBox
                      ariaLabel=""
                      name={"primaryList"}
                      label=""
                      onChange={handleChange}
                      hideClearButton={true}
                      value={primaryList}
                      error={primaryListError}
                      placeholder={PRIMARY_LIST_PLACEHOLDER}
                      readonly={isConsumptionManager}
                    />
                    {primaryListError ? (
                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-primaryList"
                      >
                        {primaryListError.message}
                      </MotifErrorMessage>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-col-lg">
            <div className="motif-row right-content">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">
                  {GLOBAL_SERVICE_CODE_SECONDARY_LIST}
                </div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <InputBox
                      name={"secondryList"}
                      ariaLabel=""
                      label=""
                      onChange={handleChange}
                      value={secondryList}
                      hideClearButton={true}
                      error={secondryListError}
                      placeholder={SECONDARY_LIST_PLACEHOLDER}
                      readonly={isConsumptionManager}
                    />
                    {secondryListError ? (
                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-primaryList"
                      >
                        {secondryListError.message}
                      </MotifErrorMessage>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-row heading">
          <div className="motif-col-lg-12">
            <div className="title">{PRODUCT_CONTACTS}</div>
          </div>
        </div>
        {/*split the row into two columns*/}
        <div className="motif-row form-item-row double-row">
          <div className="motif-col-lg">
            <div className="motif-row">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">{COMMERCIAL_OWNER_NAME}</div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <InputBox
                      ariaLabel=""
                      label=""
                      name={"commercialOwnerName"}
                      onChange={handleChange}
                      value={commercialOwnerName}
                      placeholder={EMAIL_ID_PLACEHOLDER}
                      readonly={true}
                      hideClearButton={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-col-lg">
            <div className="motif-row right-content">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">{COMMERCIAL_OWNER_PROXY_NAME}</div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <MultiSelectUserSearch
                      proxyOwners={proxyOwners}
                      readOnly={
                        isCommericalOwner() === false || isConsumptionManager
                          ? true
                          : false
                      }
                      setProxyOwners={setProxyOwners}
                      resetSearch={resetSearch}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-row form-item-row single-row">
          <div className="motif-col-lg-2 form-item label-item">
            <div className="label">{CT_PRODUCT_MANAGER}</div>
          </div>
          <div className="motif-col-lg-10 form-item">
            <div className="value">
              <div className="inputField">
                <InputBox
                  ariaLabel=""
                  name={"ctTechnicalProductManager"}
                  label=""
                  onChange={handleChange}
                  value={ctTechnicalProductManager}
                  placeholder={EMAIL_ID_PLACEHOLDER}
                  readonly={true}
                  hideClearButton={true}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="motif-row heading">
          <div className=" motif-col-lg-12">
            <div className="title">{SUPPORT}</div>
          </div>
        </div>
        <div className="motif-row form-item-row double-row">
          <div className="motif-col-lg">
            <div className="motif-row">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">{DEMAND_MANAGEMENT_TEAM_ID}</div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <Link className="link" to={DEMAND_MANAGEMENT_TEAM_ID_URL}>
                      {DEMAND_MANAGEMENT_TEAM_ID_LABEL}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-col-lg">
            <div className="motif-row right-content">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">{TEAM_EMAIL_ID}</div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <InputBox
                      ariaLabel=""
                      name={"teamEmailID"}
                      label=""
                      onChange={handleChange}
                      value={teamEmailID}
                      readonly={true}
                      hideClearButton={true}
                      placeholder={EMAIL_ID_PLACEHOLDER}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-row form-item-row double-row">
          <div className="motif-col-lg">
            <div className="motif-row">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">{PRODUCT_CONTACTS}</div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <UserSearchSelect
                      proxyOwners={productContacts}
                      setUserSearchSelect={setProductContacts}
                      name={"productContact"}
                      readOnly={isConsumptionManager}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-col-lg">
            <div className="motif-row right-content">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">{SUPPORT_LINK}</div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <InputBox
                      ariaLabel=""
                      label=""
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name={"productSupport"}
                      value={productSupport}
                      readonly={isConsumptionManager}
                      hideClearButton={true}
                      placeholder={PRODUCT_SUPPORT_LINK}
                      error={productSupportError}
                    />
                    {productSupportError ? (
                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-primaryList"
                      >
                        {productSupportError.message}
                      </MotifErrorMessage>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-row form-item-row double-row">
          <div className="motif-col-lg"></div>
          <div className="motif-col-lg">
            <div className="motif-row right-content">
              <div className="motif-col-lg-4 form-item label-item">
                <div className="label">{SUPPORT_LINK_NAME}</div>
              </div>
              <div className="motif-col-lg-8 form-item">
                <div className="value">
                  <div className="inputField">
                    <InputBox
                      ariaLabel=""
                      label=""
                      onChange={handleChange}
                      name={"productSupportText"}
                      value={productSupportText}
                      readonly={isConsumptionManager}
                      hideClearButton={true}
                      placeholder={SUPPORT_LINK_NAME}
                      error={productSupportTextError}
                    />
                    {productSupportTextError ? (
                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-primaryList"
                      >
                        {productSupportTextError.message}
                      </MotifErrorMessage>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-row headingCreateSKU">
          <div className="motif-col-lg-9">
            <div className="title">{SKUS}</div>
          </div>

          <div className="motif-col-lg-3 create-download-btn-container">
            <div className="create-download-inner">
              {isApiKeysAvailable ? (
                <MotifButton
                  size="small"
                  type="button"
                  variant="secondary"
                  onClick={downloadSKUKeysFile}
                  disabled={isExportApiLoading}
                >
                  {DOWNLOAD_API_KEYS}
                </MotifButton>
              ) : (
                <MotifTooltip
                  contentClassName="tooltip-content"
                  variant="default"
                  placement="top"
                  hideCloseButton
                  trigger={
                    <MotifButton
                      size="small"
                      type="button"
                      variant="secondary"
                      disabled={!isApiKeysAvailable}
                    >
                      {DOWNLOAD_API_KEYS}
                    </MotifButton>
                  }
                >
                  You must generate at least 1 key to download
                </MotifTooltip>
              )}
              {!isConsumptionManager && (
                <MotifButton
                  size="small"
                  type="submit"
                  variant="primary"
                  onClick={() => setShowCreateNewSkus(true)}
                >
                  {CREATE_NEW_SKUS}
                  {
                    <MotifIcon
                      iconFunction={IconoirPlus}
                      title="Computer"
                      size="24"
                    />
                  }
                </MotifButton>
              )}
            </div>
          </div>
        </div>

        <div className="motif-row no-gutter headingCreateSKUError">
          <div className="motif-col-lg-12">
            <MotifErrorMessage
              aria-live="assertive"
              role="alert"
              id="aria-error-example"
            >
              {isHavingSkusError
                ? "Please add a New SKU in order to complete the user journey"
                : ""}
            </MotifErrorMessage>
          </div>
        </div>

        <SkuList
          productId={param.id || ""}
          reloadOnNewCreation={reloadOnNewCreation}
          setReloadOnNewCreation={setReloadOnNewCreation}
          isCommercialOrProxyOwner={
            isCommericalOwner() || isCommercialProxyOwner()
          }
          setIsAnySKUretired={setIsAnySKUretired}
          hasAnyProductError={hasAnyProductError}
          isConsumptionManager={isConsumptionManager}
          defaultSearchSkuId={skuId}
        />
        {artifactSuccessMessage && (
          <SKUToast message={artifactSuccessMessage} />
        )}

        {showCreateNewSkus && (
          <CreateSkuModal
            hasAnyProductError={hasAnyProductError}
            setShow={setShowCreateNewSkus}
            show={showCreateNewSkus}
            onSave={() => {
              setReloadOnNewCreation(true);
            }}
            redirectToProductPreview={true}
          />
        )}

        {showArtifactsModal && (
          <ArtifactsModal
            show={showArtifactsModal}
            setShow={setShowArtifactsModal}
            productId={empireCode} // Pass ProductId as a prop
            editMode={false}
            refetchArtifacts={refetchArtifacts} // Pass the function to refetch artifacts after upload
          />
        )}
        {showEditArtifactsModal && (
          <ArtifactsModal
            show={showEditArtifactsModal}
            setShow={setShowEditArtifactsModal}
            productId={empireCode}
            editMode={true}
            refetchArtifacts={refetchArtifacts}
            artifactToEdit={artifactToEdit}
          />
        )}
        <ArtifactDeleteModal
          show={showArtifactDeleteModal}
          setShow={setShowArtifactDeleteModal}
          setArtifactDeleteModalItem={setArtifactDeleteModalItem}
          handleDeleteArtifactConfirm={handleDeleteArtifactConfirm}
          artifactDeleteModalItem={artifactDeleteModalItem}
          isArtifactsDeleteLoading={isArtifactsDeleteLoading}
          isArtifactsDeleteError={isArtifactsDeleteError}
          setIsArtifactsDeleteError={setIsArtifactsDeleteError}
        />
      </div>
      <div className="motif-row btnGrid">
        <div className="motif-col-lg-12 motif-col-lg-12 btnToolBar">
          <div className="btnToolBar">
            <MotifButton
              size="small"
              type="submit"
              variant="secondary"
              className="secondaryButton"
              onClick={handleSaveDraft}
              loading={updateProductIsLoadingAPi}
              disabled={updateProductIsLoadingAPi || isConsumptionManager}
            >
              {
                <MotifIcon
                  iconFunction={IconoirFloppyDisk}
                  title="Computer"
                  size="24"
                />
              }{" "}
              {SAVE_DRAFT}
            </MotifButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTProductCostSetup;
